(function LivePlannerCollection($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/LivePlanner/collection'], function onload()
		{
			$('.lp-collection-container').on('click', '.lp-content-details', function _showContentDetail(e) {
				var name        = $(this).data('name'),
					image       = $(this).data('image'),
					alt_image   = $(this).data('alt-image'),
					description = $(this).data('description'),
					$modal      = $('.modal'),
					content     = '';

				e.preventDefault();

				if (image) {
					content += '<div><img src="' + image + '" class="img-responsive" style="max-height: 400px"></div>';
					content += '<div>' + description + '</div>';
				} else {
					content += '<div>' + $(this).data('embed-code') + '</div>';
				}

				if (alt_image.length > 0) {
					image = alt_image;
				}

				$modal.find('.modal-title').text(name);
				$(".modal-dialog").addClass('modal-lg');
				$modal.find('.modal-body').html(content);

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');

				Adzuki.Ajax.get('/LivePlanner/clientViewed/' + escape(name) + '/' + encodeURIComponent(image))
				.then(function success(response) {
					// console.log(response);
				});
			});
		}, false);

		Adzuki.onload('/LivePlanner/collectionPreview/', function onload()
		{
			$('.lp-collection-container').on('click', '.lp-content-details-images', function _showContentDetail(e) {
				var name        = $(this).data('name'),
					image       = $(this).data('image'),
					image_id    = $(this).data('id'),
					$modal        = $('.modal');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/clientViewed/' + escape(name) + '/' + encodeURIComponent(image) + '/' + image_id)
					.then(function success(response) {

						$modal.find('.modal-title').text("Collection Images");
						$(".modal-dialog").addClass('modal-lg');
						$modal.find('.modal-body').html(response);

						// Call Carousel Initializer
						$modal.on('shown.bs.modal', function initCarousel() {
							$('#liveplanner-image-list').slick({
								dots          : true,
								slidesToShow  : 1,
								arrows        : true,
								slidesToScroll: 1,
								autoplay      : false,
								autoplaySpeed : 2000,
								responsive    : [
									{
										breakpoint: 992,
										settings  : {
											slidesToShow: 1,
										}
									},
									{
										breakpoint: 830,
										settings  : {
											slidesToShow: 1,
										}
									},
									{
										breakpoint: 768,
										settings  : {
											slidesToShow: 1,
										}
									}
								]
							});
						});


					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));